import classNames from 'classnames/bind';

import React from 'react';
import { Footer } from './Elements.jsx';
import Paginate from './Paginate.jsx';

import { Collection, range } from 'common';

export class DataTable extends React.Component {
  state = { items: [], page: 0 };
  contents = null;

  componentWillMount() {
    this.updateCollection(this.props.items);
  }

  componentWillReceiveProps(props) {
    this.updateCollection(props.items);
  }

  updateCollection = (data) => {
    this.contents = new Collection(data, 20);

    let page = this.state.page||0;
    if (page > this.contents.size())
      page = 0;

    this.setState({ items: this.contents.get(page) });
  }

  onPageChange = (page) => {
    this.setState({
      items: this.contents.get(page),
      page: page
    });
  }

  render() {
    const currentPage = this.state.page + 1;
    const numberOfPages =
      (this.contents != null) ? this.contents.size() : 0;

    return (
      <div>
        <table className="table table-striped table-hover">
          <thead>
            {this.props.onRenderHeader && this.props.onRenderHeader()}
          </thead>
          <tbody>
            {this.state.items.map((item, index) => (
              this.props.onRenderRow(item, index)
            ))}
          </tbody>
        </table>

        <Footer>
          <Paginate page={currentPage} numberOfPages={numberOfPages} onPageChange={this.onPageChange} />
        </Footer>

      </div>
    );
  }
};
